// extracted by mini-css-extract-plugin
export default {"labelContainer":"label_labelContainer__3KsPx","required":"label_required__rJiLw"};